import * as React from "react";
import ReactDOM from "react-dom";
import Main from "./pages/Main/";
import Maps from "./pages/Maps";
const BrowserRouter = require("react-router-dom/BrowserRouter");
const Route = require("react-router-dom/Route");
const Switch = require("react-router-dom/Switch");

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact={true} component={Main} />
        <Route path="/mapp" component={Maps} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
